import { c as _c } from "react/compiler-runtime";
import { Modal, PrimaryButton, SecondaryButton, toast } from '@systemeio/ui';
import { BlogPostId, BlogPostsInterface } from 'modules/blogs/types/blog-posts-interface';
import React, { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { SchedulePostModal } from './schedule-post-modal';
export interface ActivatePostModalProps {
  opened: boolean;
  onClose: () => void;
  post: BlogPostsInterface;
  onSchedulePost: (postId: BlogPostId, data: BlogPostsInterface) => void;
  onChangeStatus: (blogPost: BlogPostsInterface) => void;
}
export const ActivatePostModal = t0 => {
  const $ = _c(45);
  const {
    opened,
    onClose,
    post,
    onSchedulePost,
    onChangeStatus
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [openedSchedule, setOpenedSchedule] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  let t1;
  if ($[0] !== onChangeStatus || $[1] !== onClose || $[2] !== post || $[3] !== t) {
    t1 = async () => {
      setIsFetching(true);
      ;
      try {
        await onChangeStatus(post);
        onClose();
        toast.success(t("dashboard.blog.posts.activated"));
      } catch (t2) {
        const e = t2;
      }
      setIsFetching(false);
    };
    $[0] = onChangeStatus;
    $[1] = onClose;
    $[2] = post;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const activatePost = t1;
  let t2;
  if ($[5] !== t) {
    t2 = t("dashboard.blog.posts.activate_modal.confirm");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("dashboard.blog.posts.activate_modal.text");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div className="flex justify-center"><p className="text-text-primary text-base">{t3}</p></div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = isFetching && !post;
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e_0 => {
      e_0.preventDefault();
      setOpenedSchedule(true);
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("dashboard.blog.posts.activate_modal.publish_later");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <SecondaryButton disabled={t5} className="w-full" width="large" onClick={t6}>{t7}</SecondaryButton>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = !post;
  let t10;
  if ($[17] !== activatePost) {
    t10 = e_1 => {
      e_1.preventDefault();
      activatePost();
    };
    $[17] = activatePost;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t("dashboard.blog.posts.activate_modal.activate");
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== isFetching || $[22] !== t10 || $[23] !== t11 || $[24] !== t9) {
    t12 = <PrimaryButton isFetching={isFetching} disabled={t9} className="w-full" width="large" onClick={t10}>{t11}</PrimaryButton>;
    $[21] = isFetching;
    $[22] = t10;
    $[23] = t11;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t8) {
    t13 = <div className="flex justify-center gap-4">{t8}{t12}</div>;
    $[26] = t12;
    $[27] = t8;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13 || $[30] !== t4) {
    t14 = <div className="flex flex-col gap-6 lg:gap-10">{t4}{t13}</div>;
    $[29] = t13;
    $[30] = t4;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== onClose || $[33] !== opened || $[34] !== t14 || $[35] !== t2) {
    t15 = <Modal isCentered={true} opened={opened} onClose={onClose} title={t2}>{t14}</Modal>;
    $[32] = onClose;
    $[33] = opened;
    $[34] = t14;
    $[35] = t2;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => setOpenedSchedule(false);
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== onSchedulePost || $[39] !== openedSchedule || $[40] !== post) {
    t17 = <SchedulePostModal opened={openedSchedule} onClose={t16} post={post} onSchedulePost={onSchedulePost} />;
    $[38] = onSchedulePost;
    $[39] = openedSchedule;
    $[40] = post;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t15 || $[43] !== t17) {
    t18 = <>{t15}{t17}</>;
    $[42] = t15;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  return t18;
};